import { createSelector } from 'reselect'

const quiz_drop_question_selector = createSelector(
	[ state => state.quiz ],
	quizState => ({
		entityUID: quizState.entityUID,
		questions: quizState.questions.map(qst => qst.serverId),
	})
)

export default quiz_drop_question_selector
